import React from 'react';

/**
 * Overview component displays the course description and details
 */
const Overview: React.FC<any> = ({ selectedCourse }) => {
  if (!selectedCourse) {
    return (
      <div className="animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-3/4 mb-4"></div>
        <div className="h-4 bg-gray-200 rounded w-full mb-3"></div>
        <div className="h-4 bg-gray-200 rounded w-full mb-3"></div>
        <div className="h-4 bg-gray-200 rounded w-2/3 mb-6"></div>

        <div className="h-5 bg-gray-200 rounded w-1/2 mb-3"></div>
        <div className="h-4 bg-gray-200 rounded w-full mb-3"></div>
        <div className="h-4 bg-gray-200 rounded w-full mb-3"></div>
      </div>
    );
  }

  return (
    <div className="course-overview max-w-3xl">
      <div
        dangerouslySetInnerHTML={{
          __html: selectedCourse.description,
        }}
        className="prose prose-lg max-w-none dark:text-white"
      />
    </div>
  );
};

export default Overview;
